import React, { useEffect, useState } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { getDefaultUrls, addUrlMapping1, urlAllRecords1, urlMappingUUID1, getCustomerKeyValuePair, addCustomerRole, getCustomerRole, editCustomerRole } from "../../services/index";
import toast, { Toaster } from "react-hot-toast";
import { searchForMatch } from "../utils/textUtils";

const AssignRoles = (props) => {
    let userId = props.userId;
    const [responsePacket, setResponsePacket] = useState([]);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [customerOptions2, setCustomerOptions2] = useState([]);
    const [edit, setEdit] = useState(false);

    useEffect(() => {
        // getAdminRecords();
        getUserDetails(userId);
        getCustomerlist(userId);
    }, [userId]);

    const getCustomerlist = (userId) => {
        getCustomerRole(userId).then((res) => {
            if (res.errorCode == 0) {
                let d1 = res.responsePacket?.assignedCustomersList;

                if (d1 && d1?.length > 0) {
                    setEdit(true);
                    getCustomerKeyValuePair().then((res) => {
                        if (res.errorCode == 0) {
                            const d = res.responsePacket;
                            const options = d.map((a) => {
                                d1.map((b) => {
                                    if (a.key == b.customerId) {
                                        a.customerTitle = a.value;
                                        a.customerId = a.key;
                                        a.isCheck = true;
                                    } else {
                                        a.customerTitle = a.value;
                                        a.customerId = a.key;
                                    }
                                });
                                return a;
                            });
                            setCustomerOptions(options);
                            setCustomerOptions2(options);
                        } else {
                            toast(res.message);
                        }
                    });
                } else {
                    getCustomerKeyValuePair().then((res) => {
                        if (res.errorCode == 0) {
                            const d2 = res.responsePacket;
                            d2.map((a) => {
                                a.customerTitle = a.value;
                                a.customerId = a.key;
                            });
                            setCustomerOptions(d2);
                            setCustomerOptions2(d2);
                        } else {
                            toast(res.message);
                        }
                    });
                }
            }
        });
    };

    const getUserDetails = (id) => {
        urlMappingUUID1(id).then((res) => {
            if (res.errorCode == 0) {
                let urlList1 = res.responsePacket.urlList;
                urlAllRecords1().then((res) => {
                    if (res.errorCode == 0) {
                        let urlList2 = res.responsePacket;
                        if (urlList1.length == 0) {
                            getDefaultUrls(props.userType).then((res1) => {
                                let abc = urlList2.map((a) => {
                                    a.beanLinksList.map((b) => {
                                        res1.responsePacket.map((c) => {
                                            if (b.urlId === c.urlId) {
                                                b.ans = true;
                                            }
                                        });
                                        return b;
                                    });
                                    return a;
                                });

                                setResponsePacket(abc);
                            });
                        } else {
                            let abc = res.responsePacket.map((a) => {
                                a.beanLinksList.map((b) => {
                                    urlList1.map((c) => {
                                        if (b.urlId === c.urlId) {
                                            b.ans = true;
                                        }
                                    });
                                    return b;
                                });
                                return a;
                            });
                            setResponsePacket(abc);
                        }
                    } else {
                        toast(res.message, {
                            autoClose: 1000,
                        });
                    }
                });
            } else {
                toast(res.message, {
                    autoClose: 1000,
                });
            }
        });
    };

    const handleSave = () => {
        let arr = responsePacket.map((a) => a.beanLinksList.filter((b) => b.ans));
        let brr = arr.filter((a) => a.length > 0);
        let array1 = [];
        brr.map((a) => {
            a.map((b) => array1.push(b));
        });

        let data = {
            adminRoleEnum: "ROLE_NONE",
            urlList: array1,
            userId: props.userId,
            userName: props.username,
        };

        addUrlMapping1(data)
            .then((res) => {
                if (res.errorCode == 0) {
                    toast.success(res.message);
                    props.handleClose3();
                } else {
                    toast.error(res.message);
                }
            })
            .catch(() => {
                toast.error("server error");
                return;
            });
    };

    const handleUrlAnswer = (e, i, i2) => {
        const obj = [...responsePacket];
        obj[i].beanLinksList[i2].ans = e.target.checked;
        setResponsePacket(obj);
    };

    const handleUrlRight = (e, i) => {
        let x = e.target.value;
        const obj = [...responsePacket];

        if (x == "READ_ONLY") {
            obj[i].beanLinksList.map((a) => (a.methodType == "GET" ? (a.ans = true) : (a.ans = false)));
        } else if (x == "WRITE_ONLY") {
            obj[i].beanLinksList.map((a) => (a.methodType == "POST" || a.methodType == "PUT" || a.methodType == "GET" ? (a.ans = true) : (a.ans = false)));
        } else {
            obj[i].beanLinksList.map((a) => (a.methodType == "POST" || a.methodType == "PUT" || a.methodType == "GET" || a.methodType == "DELETE" ? (a.ans = true) : (a.ans = false)));
        }
        setResponsePacket(obj);
    };

    const handleCustomer = (e, a, i) => {
        const obj = [...customerOptions];
        obj[i].isCheck = e.target.checked;
        setCustomerOptions(obj);
    };

    const handleSaveCustomer = () => {
        let arr = customerOptions.filter((a) => a.isCheck);

        const data = {
            assignedCustomersList: arr,
            organisationId: props.userInfo.organisationId,
            organisationTitle: props.userInfo.organisationTitle,
            userId: props.userInfo.recordId,
            userRole: props.userInfo.userType,
            userTitle: props.userInfo.fullName,
        };
        if (edit) {
            editCustomerRole(userId, data)
                .then((res) => {
                    if (res.errorCode == 0) {
                        toast.success(res.message);
                    } else {
                        toast.error(res.message);
                    }
                })
                .catch(() => {
                    toast.error("server error");
                    return;
                });
        } else {
            addCustomerRole(data)
                .then((res) => {
                    if (res.errorCode == 0) {
                        toast.success(res.message);
                    } else {
                        toast(res.message);
                    }
                })
                .catch(() => {
                    toast.error("server error");
                    return;
                });
        }
    };
    const handleSearch = (search) => {
        const result = customerOptions2.filter((a) => searchForMatch(a.label, search));
        setCustomerOptions(result);
    };
    return (
        <>
            <div className={props.userType == "ROLE_SALES_MANAGER" ? "row3" : ""}>
                <div>
                    <div className="row2">
                        <div style={{ fontSize: "20px" }}>{props.username}</div>{" "}
                        <button className="btn btn-primary float-left " onClick={handleSave} style={{ marginLeft: "20px" }}>
                            Save URLs
                        </button>
                    </div>
                    <br />
                    <div style={{ overflowY: "scroll", height: "70vh" }}>
                        {props.userType != "ROLE_SUPER_ADMIN" ? (
                            <>
                                {responsePacket &&
                                    responsePacket.map((data, i) => {
                                        return (
                                            <>
                                                <br />
                                                <div>
                                                    <div style={{ fontSize: "20px" }}>{data?.title}</div>

                                                    <div>
                                                        <RadioGroup aria-label="RIGHTS:" name="controlled-radio-buttons-group" value={data.urlRight} onChange={(e) => handleUrlRight(e, i)}>
                                                            <div>
                                                                <FormControlLabel value="READ_ONLY" control={<Radio size="small" />} label="Read" />
                                                                <FormControlLabel value="WRITE_ONLY" control={<Radio size="small" />} label="Read-Write" />
                                                                <FormControlLabel value="FULL_ACCESS" control={<Radio size="small" />} label="Full Access" />
                                                            </div>
                                                            <table>
                                                                {data.beanLinksList.map((url, i2) => {
                                                                    return (
                                                                        <>
                                                                            <tr>
                                                                                <td>
                                                                                    <input
                                                                                        autoComplete="off"
                                                                                        type="checkbox"
                                                                                        checked={url?.ans == undefined ? (url.ans = false) : url.ans}
                                                                                        onChange={(e) => handleUrlAnswer(e, i, i2)}
                                                                                    />
                                                                                </td>
                                                                                <td>{url.title}</td>
                                                                            </tr>
                                                                        </>
                                                                    );
                                                                })}
                                                            </table>
                                                        </RadioGroup>{" "}
                                                        <hr />
                                                    </div>
                                                </div>
                                            </>
                                        );
                                    })}
                                <br />
                                <br />
                            </>
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
                {props.userType == "ROLE_SALES_MANAGER" ? (
                    <div>
                        <div className="row2">
                            <div className="row1">
                                {" "}
                                {/* <SearchRoundedIcon />
                <input autoComplete="off"
                  className="form-control"
                  onChange={(e) => handleSearch(e.target.value)}
                /> */}
                            </div>
                            <button className="btn btn-primary" onClick={handleSaveCustomer}>
                                Save Customers
                            </button>
                        </div>
                        <br />
                        <div style={{ fontSize: "15px" }}>Customers</div>
                        <br />
                        <div style={{ overflowY: "scroll", height: "70vh" }}>
                            <table>
                                {customerOptions &&
                                    customerOptions.map((a, i) => {
                                        return (
                                            <tr>
                                                <td>
                                                    <input
                                                        autoComplete="off"
                                                        type="checkbox"
                                                        checked={a?.isCheck}
                                                        // onChange={(e) => handleCustomer(e, a, i)}
                                                        onChange={(e) => handleCustomer(e, a, i)}
                                                    />
                                                </td>
                                                <td>{a?.customerTitle}</td>
                                            </tr>
                                        );
                                    })}
                            </table>
                        </div>
                    </div>
                ) : (
                    <></>
                )}
            </div>

            <Toaster />
        </>
    );
};

export default AssignRoles;
